import React from 'react';
import { Main } from 'fragments';
import { DataCollectionFragment } from "./fragments";

export const DataCollection = () => {

    return (
        <Main>
            <DataCollectionFragment />
        </Main>
    );
};
